import { Injectable, ɵɵdefineInjectable, Component, Input, ViewChild, NgModule } from '@angular/core';
import { TreeModule } from '@circlon/angular-tree-component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AaclBasicUtilsModule } from 'aacl-basic-utils';
import { AaclIconModule } from 'aacl-icon';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-tree-list.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from 'aacl-icon';
import * as ɵngcc4 from '@circlon/angular-tree-component';

const _c0 = ["tree"];
function AaclTreeListComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    ɵngcc0.ɵɵlistener("click", function AaclTreeListComponent_div_1_div_2_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r7.clearSearchText()); });
    ɵngcc0.ɵɵelementEnd()();
} }
function AaclTreeListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7)(1, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function AaclTreeListComponent_div_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.searchText = $event); })("keyup.enter", function AaclTreeListComponent_div_1_Template_input_keyup_enter_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r11.onEnterForFilter($event)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, AaclTreeListComponent_div_1_div_2_Template, 2, 0, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "button", 10);
    ɵngcc0.ɵɵlistener("click", function AaclTreeListComponent_div_1_Template_button_click_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r12.onEnterForFilter($event)); });
    ɵngcc0.ɵɵelement(4, "span", 11);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.searchText)("placeholder", ctx_r0.options.filterSearchBoxPlaceholder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.searchText);
} }
function AaclTreeListComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 14);
} }
function AaclTreeListComponent_ng_template_7_div_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23);
    ɵngcc0.ɵɵlistener("click", function AaclTreeListComponent_ng_template_7_div_1_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const node_r14 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r21.deleteNode(node_r14)); });
    ɵngcc0.ɵɵelement(1, "span", 24);
    ɵngcc0.ɵɵelementEnd();
} }
function AaclTreeListComponent_ng_template_7_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtemplate(1, AaclTreeListComponent_ng_template_7_div_1_button_1_Template, 2, 0, "button", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r14.level !== 1 && node_r14.id === ctx_r15.activeNodeId);
} }
function AaclTreeListComponent_ng_template_7_span_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 28);
} }
function AaclTreeListComponent_ng_template_7_span_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 29);
} }
function AaclTreeListComponent_ng_template_7_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵlistener("click", function AaclTreeListComponent_ng_template_7_span_2_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const node_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r27.onNodeClicked(ctx_r27.clickables.ToggleIcon, node_r14)); });
    ɵngcc0.ɵɵtemplate(1, AaclTreeListComponent_ng_template_7_span_2_span_1_Template, 1, 0, "span", 26);
    ɵngcc0.ɵɵtemplate(2, AaclTreeListComponent_ng_template_7_span_2_span_2_Template, 1, 0, "span", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !node_r14.isExpanded && !node_r14.data.expanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r14.isExpanded || node_r14.data.expanded);
} }
function AaclTreeListComponent_ng_template_7_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 30);
} }
function AaclTreeListComponent_ng_template_7_div_5_aacl_icon_1_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "aacl-icon", 34);
    ɵngcc0.ɵɵlistener("click", function AaclTreeListComponent_ng_template_7_div_5_aacl_icon_1_Template_aacl_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const node_r14 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r32.onNodeClicked(ctx_r32.clickables.CustomIcon, node_r14)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r14 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("name", node_r14.data.customIcon);
} }
function AaclTreeListComponent_ng_template_7_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵtemplate(1, AaclTreeListComponent_ng_template_7_div_5_aacl_icon_1_Template, 1, 1, "aacl-icon", 32);
    ɵngcc0.ɵɵelementStart(2, "span", 33);
    ɵngcc0.ɵɵlistener("click", function AaclTreeListComponent_ng_template_7_div_5_Template_span_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r37); const node_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r36 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r36.onNodeClicked(ctx_r36.clickables.Text, node_r14)); })("dblclick", function AaclTreeListComponent_ng_template_7_div_5_Template_span_dblclick_2_listener() { ɵngcc0.ɵɵrestoreView(_r37); const node_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r39 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r39.onNodeDBClicked(ctx_r39.clickables.Text, node_r14)); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const node_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r14.data.customIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("tree-node-menu", node_r14.data.isBold && !node_r14.data.link)("tree-node-disabled", node_r14.data.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", node_r14.data.displayText, " ");
} }
function AaclTreeListComponent_ng_template_7_div_6_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Display name cannot be empty");
    ɵngcc0.ɵɵelementEnd();
} }
function AaclTreeListComponent_ng_template_7_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 37);
    ɵngcc0.ɵɵtemplate(1, AaclTreeListComponent_ng_template_7_div_6_div_2_div_1_Template, 2, 0, "div", 38);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r14 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r14.data.displayName.length === 0);
} }
function AaclTreeListComponent_ng_template_7_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31)(1, "input", 35);
    ɵngcc0.ɵɵlistener("focus", function AaclTreeListComponent_ng_template_7_div_6_Template_input_focus_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r47); const node_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r45 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r45.onInputFocus($event, node_r14)); })("blur", function AaclTreeListComponent_ng_template_7_div_6_Template_input_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r47); const node_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r48 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r48.onInputBlur(node_r14)); })("keyup.enter", function AaclTreeListComponent_ng_template_7_div_6_Template_input_keyup_enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r47); const node_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r50 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r50.onInputBlur(node_r14)); })("ngModelChange", function AaclTreeListComponent_ng_template_7_div_6_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r47); const node_r14 = ɵngcc0.ɵɵnextContext().$implicit; return ɵngcc0.ɵɵresetView(node_r14.data.displayName = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, AaclTreeListComponent_ng_template_7_div_6_div_2_Template, 2, 1, "div", 36);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", node_r14.data.displayName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r14.data.displayName.length === 0);
} }
function AaclTreeListComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r56 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵlistener("mouseover", function AaclTreeListComponent_ng_template_7_Template_div_mouseover_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r56); const node_r14 = restoredCtx.$implicit; const ctx_r55 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r55.setNodeActive(node_r14)); });
    ɵngcc0.ɵɵtemplate(1, AaclTreeListComponent_ng_template_7_div_1_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵtemplate(2, AaclTreeListComponent_ng_template_7_span_2_Template, 3, 2, "span", 17);
    ɵngcc0.ɵɵtemplate(3, AaclTreeListComponent_ng_template_7_span_3_Template, 1, 0, "span", 18);
    ɵngcc0.ɵɵelementStart(4, "div", 19);
    ɵngcc0.ɵɵlistener("dblclick", function AaclTreeListComponent_ng_template_7_Template_div_dblclick_4_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r56); const node_r14 = restoredCtx.$implicit; const ctx_r57 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r57.onNodeDoubleClick(node_r14)); })("treeDrop", function AaclTreeListComponent_ng_template_7_Template_div_treeDrop_4_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r56); const node_r14 = restoredCtx.$implicit; return ɵngcc0.ɵɵresetView(node_r14.onDrop($event)); });
    ɵngcc0.ɵɵtemplate(5, AaclTreeListComponent_ng_template_7_div_5_Template, 4, 6, "div", 20);
    ɵngcc0.ɵɵtemplate(6, AaclTreeListComponent_ng_template_7_div_6_Template, 3, 2, "div", 20);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const node_r14 = ctx.$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("padding-left", node_r14.getNodePadding());
    ɵngcc0.ɵɵclassProp("node-container-focused", ctx_r5.options.nodeHighlightMode === ctx_r5.nodeHilightModes.Row && node_r14.isFocused);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.options.enableNodeDeletion);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r14.data.allowChildren);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !node_r14.data.allowChildren);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("node-content-container-active", node_r14.isActive)("node-content-container-focused", (!ctx_r5.options.nodeHighlightMode || ctx_r5.options.nodeHighlightMode === ctx_r5.nodeHilightModes.Text) && node_r14.data.id == ctx_r5.focusedTreeItemId);
    ɵngcc0.ɵɵproperty("treeAllowDrop", node_r14.allowDrop)("treeDrag", node_r14)("treeDragEnabled", node_r14.allowDrag());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !node_r14.data.isEditing);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r14.data.isEditing);
} }
class AaclTreeListService {
    constructor() { }
}
AaclTreeListService.ɵfac = function AaclTreeListService_Factory(t) { return new (t || AaclTreeListService)(); };
/** @nocollapse */
AaclTreeListService.ctorParameters = () => [];
/** @nocollapse */ AaclTreeListService.ɵprov = ɵɵdefineInjectable({ factory: function AaclTreeListService_Factory() { return new AaclTreeListService(); }, token: AaclTreeListService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclTreeListService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-tree-list.options.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclTreeListOptions {
    constructor() {
        this.maxTreeLevel = 2;
        this.levelPadding = 30;
        this.enableDragAndDrop = false; // enable inline node text editor by double clicking
        // enable inline node text editor by double clicking
        this.enableNodeEditing = false; // enable inline node text editor by double clicking
        // enable inline node text editor by double clicking
        this.enableNodeDeletion = false; // show node deletion icon, click to delete a node
        // enable input box for filtering tree nodes
        this.collapseAllOnLoaded = false; // the tree expand first root node by default, unless specify this property to be true;
    }
}
if (false) {
    /** @type {?} */
    AaclTreeListOptions.prototype.id;
    /** @type {?} */
    AaclTreeListOptions.prototype.items;
    /** @type {?} */
    AaclTreeListOptions.prototype.maxTreeLevel;
    /** @type {?} */
    AaclTreeListOptions.prototype.levelPadding;
    /** @type {?} */
    AaclTreeListOptions.prototype.enableDragAndDrop;
    /** @type {?} */
    AaclTreeListOptions.prototype.enableNodeEditing;
    /** @type {?} */
    AaclTreeListOptions.prototype.enableNodeDeletion;
    /** @type {?} */
    AaclTreeListOptions.prototype.enableTreeNodeFilter;
    /** @type {?} */
    AaclTreeListOptions.prototype.collapseAllOnLoaded;
    /** @type {?} */
    AaclTreeListOptions.prototype.filterSearchBoxPlaceholder;
    /** @type {?} */
    AaclTreeListOptions.prototype.nodeHighlightMode;
    /** @type {?} */
    AaclTreeListOptions.prototype.customizeClicks;
    /** @type {?} */
    AaclTreeListOptions.prototype.customClickHandler;
    /** @type {?} */
    AaclTreeListOptions.prototype.beforeExpandCollapseNode;
    /** @type {?} */
    AaclTreeListOptions.prototype.actionSubject$;
    /** @type {?} */
    AaclTreeListOptions.prototype.feedbackSubject$;
}
class AaclTreeListItem {
    constructor() {
        this.expanded = false;
    }
}
if (false) {
    /** @type {?} */
    AaclTreeListItem.prototype.id;
    /** @type {?} */
    AaclTreeListItem.prototype.expanded;
    /** @type {?} */
    AaclTreeListItem.prototype.displayText;
    /** @type {?} */
    AaclTreeListItem.prototype.link;
    /** @type {?} */
    AaclTreeListItem.prototype.isExpanded;
    /** @type {?} */
    AaclTreeListItem.prototype.isBold;
    /** @type {?} */
    AaclTreeListItem.prototype.isFocused;
    /** @type {?} */
    AaclTreeListItem.prototype.isEditing;
    /** @type {?} */
    AaclTreeListItem.prototype.allowChildren;
    /** @type {?} */
    AaclTreeListItem.prototype.items;
    /** @type {?} */
    AaclTreeListItem.prototype.parent;
    /** @type {?} */
    AaclTreeListItem.prototype.customIcon;
    /** @type {?} */
    AaclTreeListItem.prototype.disabled;
}
class AaclTreeListAction {
}
if (false) {
    /** @type {?} */
    AaclTreeListAction.prototype.type;
    /** @type {?} */
    AaclTreeListAction.prototype.payload;
}
/** @enum {string} */
const EnumAaclTreeListActionType = {
    ExpandAll: "ExpandAll",
    CollapseAll: "CollapseAll",
    AddRootNode: "AddRootNode",
    UpdateTreeListItems: "UpdateTreeListItems",
    ActivateNode: "ActivateNode",
    ExpandToNode: "ExpandToNode",
    FocusNode: "FocusNode",
    ClearSeachText: "ClearSeachText",
};
class AaclTreeListFeedback {
}
if (false) {
    /** @type {?} */
    AaclTreeListFeedback.prototype.type;
    /** @type {?} */
    AaclTreeListFeedback.prototype.payload;
}
/** @enum {string} */
const EnumAaclTreeListFeedbackType = {
    OnTreeNodeDBClick: "OnTreeNodeDBClick",
    OnTreeNodeFocus: "OnTreeNodeFocus",
    OnValidationErrors: "OnValidationErrors",
    OnBatchCommandFinished: "OnBatchCommandFinished",
};
class AaclNewTreeListItem {
}
if (false) {
    /** @type {?} */
    AaclNewTreeListItem.prototype.parentNode;
    /** @type {?} */
    AaclNewTreeListItem.prototype.newNode;
}
/** @enum {string} */
const EnumAaclTreeListNodeClickables = {
    ToggleIcon: "Toggle",
    CustomIcon: "Icon",
    Text: "Text",
};
/** @enum {string} */
const EnumAaclTreeListNodeClickHandlers = {
    Link: "Link",
    ExpandCollapse: "ExpandCollapse",
    Custom: "Custom",
    Focus: "Focus",
};
/** @enum {string} */
const EnumAaclTreeListNodeHighlightMode = {
    Row: "Row",
    Text: "Text",
};
/** @type {?} */
const DragAndDropDataFormat = 'DragAndDropData';
/** @type {?} */
const DragAndDropSourceFormat = 'DragAndDropSource';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-tree-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclTreeListComponent {
    constructor() {
        this._nodeCount = 0;
        //
    }
    /**
     * @return {?}
     */
    get nodeHilightModes() { return EnumAaclTreeListNodeHighlightMode; }
    /**
     * @return {?}
     */
    get clickables() { return EnumAaclTreeListNodeClickables; }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.options.actionSubject$) {
            this._actionSubscription = this.options.actionSubject$.subscribe((/**
             * @param {?} action
             * @return {?}
             */
            (action) => this._processActions(action)));
        }
        if (this.options.filterSearchBoxPlaceholder == null) {
            this.options.filterSearchBoxPlaceholder = 'Search here';
        }
        this.treeOtions = {
            displayField: 'displayText',
            childrenField: 'items',
            nodeHeight: 25,
            allowDrag: (/**
             * @param {?} node
             * @return {?}
             */
            (node) => {
                return this.options.enableDragAndDrop && !node.data.disabled;
            }),
            allowDrop: (/**
             * @param {?} node
             * @param {?} dropTo
             * @return {?}
             */
            (node, dropTo) => {
                return false;
                if (!this.options.enableDragAndDrop) {
                    return false;
                }
                // for top most root node dropTo.parent.parent is null
                if (!dropTo.parent.parent) {
                    return false;
                }
                // folder node
                if (node.data.allowChildren) {
                    /** @type {?} */
                    const path = [];
                    this._findNodePath(dropTo.parent, path);
                    return path.length < this.options.maxTreeLevel;
                }
                // link node
                else {
                    // If drop to node is link or drop to node is top most root node, don't allow drop
                    // If it reaches maximum tree level settings, don't allow drop
                    return dropTo.parent.parent && dropTo.parent.data.allowChildren;
                }
            }),
            allowDragoverStyling: true,
            levelPadding: this.options.levelPadding,
            useVirtualScroll: false,
            animateExpand: false,
            scrollOnActivate: true,
            actionMapping: (/** @type {?} */ ({
                mouse: {
                    dragStart: (/**
                     * @param {?} tree
                     * @param {?} node
                     * @param {?} $event
                     * @return {?}
                     */
                    (tree, node, $event) => {
                        /** @type {?} */
                        const selectedData = node.isActive ? tree.activeNodes.map((/**
                         * @param {?} n
                         * @return {?}
                         */
                        (n) => n.data)) : [node.data];
                        selectedData.sort((/**
                         * @param {?} n1
                         * @param {?} n2
                         * @return {?}
                         */
                        (n1, n2) => n1.dragOrder <= n2.dragOrder ? -1 : 1));
                        $event.dataTransfer.setData(DragAndDropDataFormat, JSON.stringify(selectedData));
                        $event.dataTransfer.setData(DragAndDropSourceFormat, this.options.id);
                    })
                }
            }))
        };
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this._treeModel = this.treeComponent.treeModel;
        this._calculateNodeCount();
        /** @type {?} */
        const rootNode = this._treeModel.getFirstRoot();
        if (rootNode && !this.options.collapseAllOnLoaded) {
            rootNode.expand();
            this._currentFocus = rootNode;
            this._currentFocus.focus();
            this.options.feedbackSubject$.next((/** @type {?} */ ({
                type: EnumAaclTreeListFeedbackType.OnTreeNodeFocus,
                payload: {
                    node: this._currentFocus,
                    level: 1
                }
            })));
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this._actionSubscription) {
            this._actionSubscription.unsubscribe();
        }
    }
    /**
     * @param {?} clickedPart
     * @param {?} node
     * @return {?}
     */
    onNodeClicked(clickedPart, node) {
        if (this.options.customizeClicks && this.options.customizeClicks.size > 0) {
            // when node click event handler is customized, do as customized.
            /** @type {?} */
            const registeredHandlers = this.options.customizeClicks.get(clickedPart);
            for (let i = 0; i < registeredHandlers.length; i++) {
                this._mapClickableHandlers(registeredHandlers[i], node);
            }
        }
        else {
            // when node click event handler is not customized, by default expand/collapse for toggle icon, go to link for text and custom icon
            switch (clickedPart) {
                case EnumAaclTreeListNodeClickables.ToggleIcon:
                    this._mapClickableHandlers(EnumAaclTreeListNodeClickHandlers.ExpandCollapse, node);
                    break;
                case EnumAaclTreeListNodeClickables.CustomIcon:
                case EnumAaclTreeListNodeClickables.Text:
                    this._mapClickableHandlers(EnumAaclTreeListNodeClickHandlers.Link, node);
                    this._mapClickableHandlers(EnumAaclTreeListNodeClickHandlers.Focus, node);
                    break;
                default:
                    break;
            }
        }
    }
    /**
     * @param {?} clickedPart
     * @param {?} node
     * @return {?}
     */
    onNodeDBClicked(clickedPart, node) {
        if (node.data.disabled)
            return;
        if (clickedPart === EnumAaclTreeListNodeClickables.Text) {
            /** @type {?} */
            const path = [];
            this._findNodePath(node, path);
            this.options.feedbackSubject$.next((/** @type {?} */ ({
                type: EnumAaclTreeListFeedbackType.OnTreeNodeDBClick,
                payload: {
                    node: node,
                    level: path.length
                }
            })));
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onNodeMove(event) {
        this._treeModel.getNodeById(event.to.parent.id).expand();
        this._treeModel.getNodeById(event.to.parent.id).data.isExpanded = true;
        this._treeModel.getFirstRoot().doForAll((/**
         * @param {?} node
         * @return {?}
         */
        (node) => {
            if (node.data.items && node.data.items.length === 0 && node.data.isExpanded) {
                this._treeModel.setExpandedNode(this._treeModel.getNodeById(node.id), false);
                node.data.isExpanded = false;
            }
        }));
    }
    /**
     * @param {?} node
     * @return {?}
     */
    onNodeFocus(node) {
        node.focus();
        this.focusedTreeItemId = node.data.id;
        /** @type {?} */
        const path = [];
        this._findNodePath(node, path);
        this.options.feedbackSubject$.next((/** @type {?} */ ({
            type: EnumAaclTreeListFeedbackType.OnTreeNodeFocus,
            payload: {
                node: node,
                level: path.length
            }
        })));
        if (node.data && node.data.allowChildren) {
            this._currentFocus = node;
        }
        else if (!node.data.allowChildren) {
            this._currentFocus = node.parent;
        }
    }
    /**
     * @param {?} node
     * @return {?}
     */
    onNodeToggleExpand(node) {
        this._toggleCheck(node).then((/**
         * @param {?} result
         * @return {?}
         */
        result => {
            if (result) {
                if (node.hasChildren) {
                    node.toggleExpanded();
                }
                node.data.isExpanded = !node.data.isExpanded;
            }
        }));
    }
    /**
     * @param {?} node
     * @return {?}
     */
    onNodeDoubleClick(node) {
        if (node.level !== 1 && this.options.enableNodeEditing) {
            node.data.isEditing = true;
        }
    }
    /**
     * @param {?} node
     * @return {?}
     */
    onInputBlur(node) {
        if (node.data.displayName.length === 0) {
            this.options.feedbackSubject$.next({
                type: EnumAaclTreeListFeedbackType.OnValidationErrors,
                payload: true
            });
        }
        else {
            node.data.isEditing = false;
            this.options.feedbackSubject$.next({
                type: EnumAaclTreeListFeedbackType.OnValidationErrors,
                payload: false
            });
        }
    }
    /**
     * @param {?} event
     * @param {?} node
     * @return {?}
     */
    onInputFocus(event, node) {
        event.target.value = node.data.displayName;
        event.target.focus();
        event.target.select();
    }
    /**
     * @param {?} node
     * @return {?}
     */
    deleteNode(node) {
        /** @type {?} */
        const path = [];
        this._findNodePath(node, path);
        this._deleteNodeFromTreeModel(0, path, this.options.items);
        // If all items in submenu are deleted set isExpanded on parent to false
        // default value of isExpanded is undefined
        if (node.parent.hasChildren && node.parent.data.items.length === 0) {
            node.parent.setIsExpanded(false);
            node.parent.data.isExpanded = !node.parent.data.isExpanded;
        }
        this._treeModel.update();
    }
    /**
     * @param {?} node
     * @return {?}
     */
    setNodeActive(node) {
        this.activeNodeId = node.id;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onEnterForFilter(event) {
        /** @type {?} */
        const filter = this.searchText;
        if (filter === '') {
            this._treeModel.clearFilter();
        }
        else {
            this.applyTreeNodeFilter(filter);
        }
    }
    /**
     * @return {?}
     */
    clearSearchText() {
        this.searchText = '';
        this._treeModel.clearFilter();
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    applyTreeNodeFilter(filter) {
        if (this.options.enableTreeNodeFilter) {
            // when 'autoShow' is true, the performance issue will be serious in large data scenario
            this._treeModel.filterNodes(filter, false);
            if (this._treeModel.getFirstRoot().isHidden) {
                // to show root node if filter does not match any node.
                this._treeModel.getFirstRoot().setIsHidden(false);
            }
        }
    }
    /**
     * @return {?}
     */
    onTreeModelUpdated() {
        /** @type {?} */
        const rootNode = this._treeModel.getFirstRoot();
        if (rootNode && !this.options.collapseAllOnLoaded) {
            rootNode.expand();
        }
    }
    /**
     * @private
     * @param {?} index
     * @param {?} path
     * @param {?} items
     * @return {?}
     */
    _deleteNodeFromTreeModel(index, path, items) {
        if (index < path.length - 1) {
            return this._deleteNodeFromTreeModel(index + 1, path, items[path[index]].items);
        }
        items.splice(path[path.length - 1], 1);
    }
    /**
     * @private
     * @param {?} action
     * @return {?}
     */
    _processActions(action) {
        switch (action.type) {
            case EnumAaclTreeListActionType.ExpandAll:
                this._expandAll();
                break;
            case EnumAaclTreeListActionType.CollapseAll:
                this._collapseAll();
                break;
            case EnumAaclTreeListActionType.ClearSeachText:
                this.clearSearchText();
                this._collapseAll();
                break;
            case EnumAaclTreeListActionType.AddRootNode:
                this._addTreeListItem(action.payload);
                this._treeModel.update();
                this._calculateNodeCount();
                if (!this.options.collapseAllOnLoaded) {
                    this._treeModel.getNodeById(this._currentFocus.id).expand();
                }
                break;
            case EnumAaclTreeListActionType.UpdateTreeListItems:
                this.options.items = action.payload;
                this._treeModel.update();
                break;
            case EnumAaclTreeListActionType.ActivateNode:
                this._setActiveNode(action.payload);
                break;
            case EnumAaclTreeListActionType.ExpandToNode:
                this._expandToNode(action.payload);
                break;
            case EnumAaclTreeListActionType.FocusNode:
                this._setFocusNode(action.payload);
                break;
            default:
                break;
        }
    }
    /**
     * @private
     * @param {?} newItem
     * @return {?}
     */
    _addTreeListItem(newItem) {
        if (!newItem.parentNode) {
            this.options.items[0].items.push(newItem.newNode);
        }
        else if (this._currentFocus) {
            this._currentFocus = this._treeModel.getNodeById(this._currentFocus.id);
            /** @type {?} */
            const path = [];
            this._findNodePath(this._currentFocus, path);
            // only add the new node when current tree node level is less than maximum level settings
            if (path.length <= this.options.maxTreeLevel) {
                this._addNewNodeToTreeModel(0, path, this.options.items, newItem.newNode);
            }
        }
    }
    /**
     * @private
     * @param {?} index
     * @param {?} path
     * @param {?} items
     * @param {?} newNode
     * @return {?}
     */
    _addNewNodeToTreeModel(index, path, items, newNode) {
        if (index < path.length) {
            return this._addNewNodeToTreeModel(index + 1, path, items[path[index]].items, newNode);
        }
        items.push(newNode);
    }
    /**
     * @private
     * @param {?} node
     * @param {?} path
     * @return {?}
     */
    _findNodePath(node, path) {
        if (node.id) {
            path.unshift(node.index);
        }
        if (node.level === 1) {
            return path;
        }
        if (node.parent) {
            return this._findNodePath(node.parent, path);
        }
    }
    /**
     * @private
     * @return {?}
     */
    _expandAll() {
        this._treeModel.expandAll();
        this._toggleExpanded(true);
    }
    /**
     * @private
     * @return {?}
     */
    _collapseAll() {
        this._treeModel.collapseAll();
        this._toggleExpanded(false);
    }
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    _toggleExpanded(value) {
        /** @type {?} */
        let count = 0;
        this._treeModel.getFirstRoot().doForAll((/**
         * @param {?} node
         * @return {?}
         */
        (node) => {
            count++;
            if (count === this._nodeCount) {
                this._feedbackBatchOperationFinished(value ? EnumAaclTreeListActionType.ExpandAll : EnumAaclTreeListActionType.CollapseAll, count);
            }
            return node.data.isExpanded = value;
        }));
    }
    /**
     * @private
     * @param {?} handler
     * @param {?} node
     * @return {?}
     */
    _mapClickableHandlers(handler, node) {
        switch (handler) {
            case EnumAaclTreeListNodeClickHandlers.ExpandCollapse:
                this.onNodeToggleExpand(node);
                break;
            case EnumAaclTreeListNodeClickHandlers.Link:
                if (node.data.link) {
                    window.open(node.data.link, '_blank');
                }
                break;
            case EnumAaclTreeListNodeClickHandlers.Custom:
                if (this.options.customClickHandler) {
                    this.options.customClickHandler(node);
                }
                break;
            case EnumAaclTreeListNodeClickHandlers.Focus:
                this.onNodeFocus(node);
                break;
            default:
                break;
        }
    }
    /**
     * @private
     * @param {?} selector
     * @return {?}
     */
    _setActiveNode(selector) {
        /** @type {?} */
        const node = this._treeModel.getNodeBy(selector);
        if (node) {
            node.setIsActive(true);
            this._feedbackBatchOperationFinished(EnumAaclTreeListActionType.ActivateNode, true);
            return true;
        }
        else {
            this._feedbackBatchOperationFinished(EnumAaclTreeListActionType.ActivateNode, false);
            return false;
        }
    }
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    _setFocusNode(data) {
        this.focusedTreeItemId = data ? data.id : null;
    }
    /**
     * @private
     * @param {?} selector
     * @return {?}
     */
    _expandToNode(selector) {
        /** @type {?} */
        const node = this._treeModel.getNodeBy(selector);
        if (node) {
            this._expandToNodePromise(node).then((/**
             * @param {?} expandedCount
             * @return {?}
             */
            (expandedCount) => {
                this._feedbackBatchOperationFinished(EnumAaclTreeListActionType.ExpandToNode, expandedCount);
            }));
            return true;
        }
        else {
            this._feedbackBatchOperationFinished(EnumAaclTreeListActionType.ExpandToNode, 0);
            return false;
        }
    }
    /**
     * @private
     * @param {?} node
     * @return {?}
     */
    _expandToNodePromise(node) {
        return new Promise((/**
         * @param {?} resolve
         * @return {?}
         */
        resolve => {
            /** @type {?} */
            let expandedCount = 0;
            this._toggleCheck(node).then((/**
             * @param {?} result
             * @return {?}
             */
            result => {
                if (result) {
                    if (node && !node.isRoot) {
                        /** @type {?} */
                        let parent = node;
                        do {
                            parent = parent.parent;
                            parent.setIsExpanded(true);
                            expandedCount++;
                        } while (!parent.isRoot);
                    }
                }
                resolve(expandedCount);
            }));
        }));
    }
    /**
     * @private
     * @param {?} node
     * @return {?}
     */
    _toggleCheck(node) {
        if (!this.options.beforeExpandCollapseNode) {
            return new Promise((/**
             * @param {?} resolve
             * @return {?}
             */
            resolve => resolve(true)));
        }
        else {
            return this.options.beforeExpandCollapseNode(node);
        }
    }
    /**
     * @private
     * @param {?} workflow
     * @param {?} result
     * @return {?}
     */
    _feedbackBatchOperationFinished(workflow, result) {
        /** @type {?} */
        const action = new AaclTreeListFeedback();
        action.type = EnumAaclTreeListFeedbackType.OnBatchCommandFinished;
        action.payload = { workflow: workflow, result: result };
        this.options.feedbackSubject$.next(action);
    }
    /**
     * @private
     * @return {?}
     */
    _calculateNodeCount() {
        this._nodeCount = 0;
        this._treeModel.getFirstRoot().doForAll((/**
         * @param {?} node
         * @return {?}
         */
        (node) => {
            this._nodeCount++;
        }));
    }
}
AaclTreeListComponent.ɵfac = function AaclTreeListComponent_Factory(t) { return new (t || AaclTreeListComponent)(); };
AaclTreeListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AaclTreeListComponent, selectors: [["aacl-tree-list"]], viewQuery: function AaclTreeListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.treeComponent = _t.first);
    } }, inputs: { options: "options" }, decls: 9, vars: 3, consts: [[1, "aacl-tree-list-container"], ["class", "search-box", 4, "ngIf"], [1, "tree-node-container"], [3, "nodes", "options", "moveNode", "updateData"], ["tree", ""], ["treeDropSlotTemplate", ""], ["treeNodeWrapperTemplate", ""], [1, "search-box"], [1, "search-input", 3, "ngModel", "placeholder", "ngModelChange", "keyup.enter"], ["class", "search-delete-warpper", 4, "ngIf"], [1, "search-button", 3, "click"], [1, "k-icon", "k-i-search"], [1, "search-delete-warpper"], [1, "advent-icon", "advent-i-filter-clear", "advent-icon-14", "search-delete", 3, "click"], [2, "height", "20px", "background-color", "green"], [1, "node-container", 3, "mouseover"], ["class", "delete-button-container", 4, "ngIf"], ["class", "toggle-children-container", 3, "click", 4, "ngIf"], ["class", "toggle-children-container-placeholder", 4, "ngIf"], [1, "node-content-container", 3, "treeAllowDrop", "treeDrag", "treeDragEnabled", "dblclick", "treeDrop"], ["class", "tree-node-text-container", 4, "ngIf"], [1, "delete-button-container"], ["class", "delete-node-button", 3, "click", 4, "ngIf"], [1, "delete-node-button", 3, "click"], [1, "advent-icon", "advent-i-filter-clear", "advent-icon-14"], [1, "toggle-children-container", 3, "click"], ["class", "k-icon k-i-arrow-chevron-right", 4, "ngIf"], ["class", "k-icon k-i-arrow-chevron-down", 4, "ngIf"], [1, "k-icon", "k-i-arrow-chevron-right"], [1, "k-icon", "k-i-arrow-chevron-down"], [1, "toggle-children-container-placeholder"], [1, "tree-node-text-container"], [3, "name", "click", 4, "ngIf"], [1, "tree-node-display-name", 3, "click", "dblclick"], [3, "name", "click"], ["apxAutoFocus", "", "placeholder", "Enter favorite name here", 1, "tree-node-input-box", 3, "ngModel", "focus", "blur", "keyup.enter", "ngModelChange"], ["class", "validation-message-container", 4, "ngIf"], [1, "validation-message-container"], [4, "ngIf"]], template: function AaclTreeListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AaclTreeListComponent_div_1_Template, 5, 3, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2)(3, "tree-root", 3, 4);
        ɵngcc0.ɵɵlistener("moveNode", function AaclTreeListComponent_Template_tree_root_moveNode_3_listener($event) { return ctx.onNodeMove($event); })("updateData", function AaclTreeListComponent_Template_tree_root_updateData_3_listener() { return ctx.onTreeModelUpdated(); });
        ɵngcc0.ɵɵtemplate(5, AaclTreeListComponent_ng_template_5_Template, 1, 0, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, AaclTreeListComponent_ng_template_7_Template, 7, 16, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.options.enableTreeNodeFilter);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("nodes", ctx.options.items)("options", ctx.treeOtions);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc3.AaclIconComponent, ɵngcc4.TreeComponent, ɵngcc4.TreeDropDirective, ɵngcc4.TreeDragDirective], styles: [".aacl-tree-list-container[_ngcontent-%COMP%]{cursor:pointer;height:100%}.aacl-tree-list-container[_ngcontent-%COMP%]   .search-box[_ngcontent-%COMP%]{background:#fff;border:solid #bfbfbf;border-top-left-radius:3px;border-top-right-radius:3px;border-width:1px 1px 0;box-sizing:content-box;color:#282828;display:flex;flex:0 0 auto;flex-flow:row nowrap;font-family:Source Sans Pro,sans-serif;font-size:14px;height:30px;justify-content:flex-end;line-height:1em;margin:0 10px;padding:0 12px;width:calc(100% - 45px)}.aacl-tree-list-container[_ngcontent-%COMP%]   .search-box[_ngcontent-%COMP%]   .search-input[_ngcontent-%COMP%]{border:none;flex:1;outline:none!important}.aacl-tree-list-container[_ngcontent-%COMP%]   .search-box[_ngcontent-%COMP%]   .search-input[_ngcontent-%COMP%]::-moz-placeholder{color:#bfbfbf}.aacl-tree-list-container[_ngcontent-%COMP%]   .search-box[_ngcontent-%COMP%]   .search-input[_ngcontent-%COMP%]:-ms-input-placeholder{color:#bfbfbf}.aacl-tree-list-container[_ngcontent-%COMP%]   .search-box[_ngcontent-%COMP%]   .search-input[_ngcontent-%COMP%]::placeholder{color:#bfbfbf}.aacl-tree-list-container[_ngcontent-%COMP%]   .search-box[_ngcontent-%COMP%]   .search-delete-warpper[_ngcontent-%COMP%]{line-height:32px}.aacl-tree-list-container[_ngcontent-%COMP%]   .search-box[_ngcontent-%COMP%]   .search-delete-warpper[_ngcontent-%COMP%]   .search-delete[_ngcontent-%COMP%]{cursor:pointer}.aacl-tree-list-container[_ngcontent-%COMP%]   .search-box[_ngcontent-%COMP%]   .search-button[_ngcontent-%COMP%]{background:transparent;border:none;color:#bfbfbf;height:30px;outline:none!important;padding:0;width:30px}.aacl-tree-list-container[_ngcontent-%COMP%]   .tree-node-container[_ngcontent-%COMP%]{border:1px solid #bfbfbf;height:calc(100% - 50px);margin:0 9px 0 10px;overflow-y:auto}.aacl-tree-list-container[_ngcontent-%COMP%]   .delete-button-container[_ngcontent-%COMP%]{display:inline-block;width:30px}.aacl-tree-list-container[_ngcontent-%COMP%]   .delete-node-button[_ngcontent-%COMP%]{align-items:center;background:none;border:none;box-shadow:none!important;display:inline-flex;height:100%;justify-content:center;outline:none!important;padding:0;width:24px}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]{display:flex}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container.node-container-focused[_ngcontent-%COMP%]{background-color:#06bee1}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .toggle-children-container[_ngcontent-%COMP%]{align-items:center;display:inline-flex;justify-content:center;width:20px}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .toggle-children-container[_ngcontent-%COMP%]   .k-icon[_ngcontent-%COMP%]{font-size:16px}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .toggle-children-container-placeholder[_ngcontent-%COMP%]{width:20px}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]:hover:not(.node-container-focused){background-color:#e6f8fc}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .node-content-container[_ngcontent-%COMP%]{align-items:center;display:inline-flex;height:30px;width:100%}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .node-content-container[_ngcontent-%COMP%]   .k-icon[_ngcontent-%COMP%]{font-size:16px;margin:0;padding:0}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .node-content-container[_ngcontent-%COMP%]   .tree-node-text-container[_ngcontent-%COMP%]{align-items:center;box-sizing:border-box;display:flex;flex-direction:row;height:100%;width:100%}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .node-content-container[_ngcontent-%COMP%]   .tree-node-text-container[_ngcontent-%COMP%]   .tree-node-display-name[_ngcontent-%COMP%]{align-items:center;box-sizing:border-box;display:inline-flex;font-family:Source Sans Pro,sans-serif;font-size:14px;height:100%;padding:0 10px;white-space:nowrap;width:auto}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .node-content-container[_ngcontent-%COMP%]   .tree-node-text-container[_ngcontent-%COMP%]   .tree-node-disabled[_ngcontent-%COMP%]{color:#d3d3d3}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .node-content-container[_ngcontent-%COMP%]   .tree-node-text-container[_ngcontent-%COMP%]   .tree-node-input-box[_ngcontent-%COMP%]{height:25px;width:calc(100% - 20px)}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .node-content-container[_ngcontent-%COMP%]   .tree-node-text-container[_ngcontent-%COMP%]   .tree-node-menu[_ngcontent-%COMP%]{font-weight:700}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .node-content-container[_ngcontent-%COMP%]   .tree-node-text-container[_ngcontent-%COMP%]   .validation-message-container[_ngcontent-%COMP%]{color:red;font-size:12px;height:10px}.aacl-tree-list-container[_ngcontent-%COMP%]   .node-container[_ngcontent-%COMP%]   .node-content-container.node-content-container-focused[_ngcontent-%COMP%]   .tree-node-display-name[_ngcontent-%COMP%]{background-color:#06bee1;color:#fff}"] });
/** @nocollapse */
AaclTreeListComponent.ctorParameters = () => [];
AaclTreeListComponent.propDecorators = {
    options: [{ type: Input }],
    treeComponent: [{ type: ViewChild, args: ['tree', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclTreeListComponent, [{
        type: Component,
        args: [{ selector: 'aacl-tree-list', template: "<div class=\"aacl-tree-list-container\">\r\n\t<div class=\"search-box\" *ngIf=\"options.enableTreeNodeFilter\">\r\n\t\t<input class=\"search-input\" [(ngModel)]=\"searchText\" (keyup.enter)=\"onEnterForFilter($event)\" [placeholder]=\"options.filterSearchBoxPlaceholder\"/>\r\n\t\t<div class=\"search-delete-warpper\" *ngIf=\"searchText\">\r\n\t\t\t<span class=\"advent-icon advent-i-filter-clear advent-icon-14 search-delete\" (click)=\"clearSearchText()\"></span>\r\n\t\t</div>\r\n\t\t<button class=\"search-button\" (click)=\"onEnterForFilter($event)\">\r\n\t\t\t<span class=\"k-icon k-i-search\"></span>\r\n\t\t</button>\r\n\t</div>\r\n\t<div class=\"tree-node-container\">\r\n\t\t<tree-root #tree [nodes]=\"options.items\" [options]=\"treeOtions\" (moveNode)=\"onNodeMove($event)\" (updateData)=\"onTreeModelUpdated()\">\r\n\t\t\t<ng-template #treeDropSlotTemplate let-node>\r\n\t\t\t\t<div style=\"height: 20px; background-color: green;\"></div>\r\n\t\t\t</ng-template>\r\n\t\t\t<ng-template #treeNodeWrapperTemplate let-node>\r\n\t\t\t\t<div class=\"node-container\"\r\n\t\t\t\t\t[class.node-container-focused]=\"options.nodeHighlightMode === nodeHilightModes.Row && node.isFocused\"\r\n\t\t\t\t\t[style.padding-left]=\"node.getNodePadding()\"\r\n\t\t\t\t\t(mouseover)=\"setNodeActive(node)\">\r\n\t\t\t\t\t<div class=\"delete-button-container\" *ngIf=\"options.enableNodeDeletion\">\r\n\t\t\t\t\t\t<button class=\"delete-node-button\" (click)=\"deleteNode(node)\" *ngIf=\"node.level !== 1 && node.id === activeNodeId\">\r\n\t\t\t\t\t\t\t<span class=\"advent-icon advent-i-filter-clear advent-icon-14\"></span>\r\n\t\t\t\t\t\t</button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<span class=\"toggle-children-container\" *ngIf=\"node.data.allowChildren\" (click)=\"onNodeClicked(clickables.ToggleIcon,node)\">\r\n\t\t\t\t\t\t<span class=\"k-icon k-i-arrow-chevron-right\" *ngIf=\"!node.isExpanded && !node.data.expanded\"></span>\r\n\t\t\t\t\t\t<span class=\"k-icon k-i-arrow-chevron-down\" *ngIf=\"node.isExpanded || node.data.expanded\"></span>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"toggle-children-container-placeholder\" *ngIf=\"!node.data.allowChildren\"></span>\r\n\t\t\t\t\t<div class=\"node-content-container\"\r\n\t\t\t\t\t\t[class.node-content-container-active]=\"node.isActive\"\r\n\t\t\t\t\t\t[class.node-content-container-focused]=\"(!options.nodeHighlightMode || options.nodeHighlightMode === nodeHilightModes.Text) && node.data.id == focusedTreeItemId\"\r\n\t\t\t\t\t\t(dblclick)=\"onNodeDoubleClick(node)\"\r\n\t\t\t\t\t\t(treeDrop)=\"node.onDrop($event)\"\r\n\t\t\t\t\t\t[treeAllowDrop]=\"node.allowDrop\"\r\n\t\t\t\t\t\t[treeDrag]=\"node\"\r\n\t\t\t\t\t\t[treeDragEnabled]=\"node.allowDrag()\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t<div class=\"tree-node-text-container\" *ngIf=\"!node.data.isEditing\">\r\n\t\t\t\t\t\t\t<aacl-icon *ngIf=\"node.data.customIcon\" (click)=\"onNodeClicked(clickables.CustomIcon,node)\" [name]='node.data.customIcon'></aacl-icon>\r\n\t\t\t\t\t\t\t<span class=\"tree-node-display-name\"\r\n\t\t\t\t\t\t\t\t[class.tree-node-menu]=\"node.data.isBold && !node.data.link\"\r\n\t\t\t\t\t\t\t\t[class.tree-node-disabled]=\"node.data.disabled\"\r\n\t\t\t\t\t\t\t\t(click)=\"onNodeClicked(clickables.Text,node)\"\r\n\t\t\t\t\t\t\t\t(dblclick)=\"onNodeDBClicked(clickables.Text, node)\">\r\n\t\t\t\t\t\t\t\t{{node.data.displayText}}\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"tree-node-text-container\" *ngIf=\"node.data.isEditing\">\r\n\t\t\t\t\t\t\t<input class=\"tree-node-input-box\"\r\n\t\t\t\t\t\t\t\t\tapxAutoFocus\r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Enter favorite name here\"\r\n\t\t\t\t\t\t\t\t\t(focus)=\"onInputFocus($event, node)\"\r\n\t\t\t\t\t\t\t\t\t(blur)=\"onInputBlur(node)\"\r\n\t\t\t\t\t\t\t\t\t(keyup.enter)=\"onInputBlur(node)\"\r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"node.data.displayName\">\r\n\t\t\t\t\t\t\t<div class=\"validation-message-container\" *ngIf=\"node.data.displayName.length === 0\">\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"node.data.displayName.length === 0\">Display name cannot be empty</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</ng-template>\r\n\t\t</tree-root>\r\n\t</div>\r\n</div>\r\n", styles: [".aacl-tree-list-container{cursor:pointer;height:100%}.aacl-tree-list-container .search-box{background:#fff;border:solid #bfbfbf;border-top-left-radius:3px;border-top-right-radius:3px;border-width:1px 1px 0;box-sizing:content-box;color:#282828;display:flex;flex:0 0 auto;flex-flow:row nowrap;font-family:Source Sans Pro,sans-serif;font-size:14px;height:30px;justify-content:flex-end;line-height:1em;margin:0 10px;padding:0 12px;width:calc(100% - 45px)}.aacl-tree-list-container .search-box .search-input{border:none;flex:1;outline:none!important}.aacl-tree-list-container .search-box .search-input::-moz-placeholder{color:#bfbfbf}.aacl-tree-list-container .search-box .search-input:-ms-input-placeholder{color:#bfbfbf}.aacl-tree-list-container .search-box .search-input::placeholder{color:#bfbfbf}.aacl-tree-list-container .search-box .search-delete-warpper{line-height:32px}.aacl-tree-list-container .search-box .search-delete-warpper .search-delete{cursor:pointer}.aacl-tree-list-container .search-box .search-button{background:transparent;border:none;color:#bfbfbf;height:30px;outline:none!important;padding:0;width:30px}.aacl-tree-list-container .tree-node-container{border:1px solid #bfbfbf;height:calc(100% - 50px);margin:0 9px 0 10px;overflow-y:auto}.aacl-tree-list-container .delete-button-container{display:inline-block;width:30px}.aacl-tree-list-container .delete-node-button{align-items:center;background:none;border:none;box-shadow:none!important;display:inline-flex;height:100%;justify-content:center;outline:none!important;padding:0;width:24px}.aacl-tree-list-container .node-container{display:flex}.aacl-tree-list-container .node-container.node-container-focused{background-color:#06bee1}.aacl-tree-list-container .node-container .toggle-children-container{align-items:center;display:inline-flex;justify-content:center;width:20px}.aacl-tree-list-container .node-container .toggle-children-container .k-icon{font-size:16px}.aacl-tree-list-container .node-container .toggle-children-container-placeholder{width:20px}.aacl-tree-list-container .node-container:hover:not(.node-container-focused){background-color:#e6f8fc}.aacl-tree-list-container .node-container .node-content-container{align-items:center;display:inline-flex;height:30px;width:100%}.aacl-tree-list-container .node-container .node-content-container .k-icon{font-size:16px;margin:0;padding:0}.aacl-tree-list-container .node-container .node-content-container .tree-node-text-container{align-items:center;box-sizing:border-box;display:flex;flex-direction:row;height:100%;width:100%}.aacl-tree-list-container .node-container .node-content-container .tree-node-text-container .tree-node-display-name{align-items:center;box-sizing:border-box;display:inline-flex;font-family:Source Sans Pro,sans-serif;font-size:14px;height:100%;padding:0 10px;white-space:nowrap;width:auto}.aacl-tree-list-container .node-container .node-content-container .tree-node-text-container .tree-node-disabled{color:#d3d3d3}.aacl-tree-list-container .node-container .node-content-container .tree-node-text-container .tree-node-input-box{height:25px;width:calc(100% - 20px)}.aacl-tree-list-container .node-container .node-content-container .tree-node-text-container .tree-node-menu{font-weight:700}.aacl-tree-list-container .node-container .node-content-container .tree-node-text-container .validation-message-container{color:red;font-size:12px;height:10px}.aacl-tree-list-container .node-container .node-content-container.node-content-container-focused .tree-node-display-name{background-color:#06bee1;color:#fff}"] }]
    }], function () { return []; }, { options: [{
            type: Input
        }], treeComponent: [{
            type: ViewChild,
            args: ['tree', { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    AaclTreeListComponent.prototype.options;
    /** @type {?} */
    AaclTreeListComponent.prototype.treeComponent;
    /** @type {?} */
    AaclTreeListComponent.prototype.treeOtions;
    /** @type {?} */
    AaclTreeListComponent.prototype.activeNodeId;
    /** @type {?} */
    AaclTreeListComponent.prototype.focusedTreeItemId;
    /** @type {?} */
    AaclTreeListComponent.prototype.searchText;
    /**
     * @type {?}
     * @private
     */
    AaclTreeListComponent.prototype._nodeCount;
    /**
     * @type {?}
     * @private
     */
    AaclTreeListComponent.prototype._treeModel;
    /**
     * @type {?}
     * @private
     */
    AaclTreeListComponent.prototype._actionSubscription;
    /**
     * @type {?}
     * @private
     */
    AaclTreeListComponent.prototype._currentFocus;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-tree-list.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclTreeListModule {
}
AaclTreeListModule.ɵfac = function AaclTreeListModule_Factory(t) { return new (t || AaclTreeListModule)(); };
AaclTreeListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AaclTreeListModule });
AaclTreeListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        AaclBasicUtilsModule,
        AaclIconModule,
        TreeModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclTreeListModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AaclTreeListComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    AaclBasicUtilsModule,
                    AaclIconModule,
                    TreeModule
                ],
                exports: [
                    AaclTreeListComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AaclTreeListModule, { declarations: function () { return [AaclTreeListComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        AaclBasicUtilsModule,
        AaclIconModule,
        TreeModule]; }, exports: function () { return [AaclTreeListComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: aacl-tree-list.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AaclNewTreeListItem, AaclTreeListAction, AaclTreeListComponent, AaclTreeListFeedback, AaclTreeListItem, AaclTreeListModule, AaclTreeListOptions, AaclTreeListService, DragAndDropDataFormat, DragAndDropSourceFormat, EnumAaclTreeListActionType, EnumAaclTreeListFeedbackType, EnumAaclTreeListNodeClickHandlers, EnumAaclTreeListNodeClickables, EnumAaclTreeListNodeHighlightMode };

